import { UserMngItem } from '@/types/userMng';
import { Form, Input, Modal, Select } from 'antd';
import { useEffect } from 'react';

export type AlertConfirmDialogType = 'batch' | 'single';

interface AlertConfirmDialogProps {
  type?: AlertConfirmDialogType;
  user?: UserMngItem;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (values: { alertDuration: number; alertReason: string }) => void;
}

const AlertConfirmDialog = ({
  type,
  user,
  isOpen,
  onClose,
  onConfirm,
}: AlertConfirmDialogProps) => {
  const [alertForm] = Form.useForm<{
    alertDuration: number;
    alertReason: string;
  }>();

  const handleOk = () => {
    const values = alertForm.getFieldsValue();
    onConfirm(values);
  };

  useEffect(() => {
    alertForm.resetFields();
  }, [isOpen, alertForm]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={type === 'single' ? `警告用户: ${user?.name}?` : '确定批量警告?'}
      okButtonProps={{
        type: 'primary',
        htmlType: 'submit',
        danger: true,
      }}
      destroyOnClose
      modalRender={(node) => (
        <Form layout="vertical" form={alertForm} onFinish={handleOk}>
          {node}
        </Form>
      )}
    >
      <div>
        <div>被警告用户的帖子将无法获得流量曝光，仅自己可见</div>
        <Form.Item
          label="警告时长"
          name="alertDuration"
          required
          rules={[{ required: true, message: '请选择警告时长' }]}
        >
          <Select>
            <Select.Option value={7}>7天</Select.Option>
            <Select.Option value={14}>14天</Select.Option>
            <Select.Option value={30}>30天</Select.Option>
            <Select.Option value={60}>60天</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="警告理由"
          name="alertReason"
          required
          rules={[{ required: true, message: '请输入警告理由' }]}
        >
          <Input.TextArea rows={4} maxLength={200} />
        </Form.Item>
      </div>
    </Modal>
  );
};

export default AlertConfirmDialog;
